import { SUPERADMIN_ROLE } from "@src/utility/constants/panel/common";
import { SuperAdminDefaultRoute } from "@src/router/routes";
import { UserContext } from "@context/user";
import Validations from "@helpers/validations";
import { object } from "yup";
import { setItemToStore } from "@src/utility/helpers/utils";
import useAxios from "@hooks/use-axios";
import { useContext } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import usePanelAbility from "@src/utility/hooks/use-panel-ability";
import { yupResolver } from "@hookform/resolvers/yup";

const defaultValues = {
    email   : "",
    password: ""
};

const useSuperadminLogin = () => {
    const { handleUserData } = useContext(UserContext);
    const { axiosInstance, loading } = useAxios({ base: "superAdmin" });
    const { emailRequiredValidation, minMaxRequiredString } = Validations();
    const navigate = useNavigate();
    const { handlePanelAbility } = usePanelAbility();

    const {
        control,
        handleSubmit,
        formState: { errors }
    } = useForm({
        defaultValues,
        resolver: yupResolver(
            object().shape({
                email   : emailRequiredValidation({ name: "Email" }),
                password: minMaxRequiredString({ name: "Password", min: 8, max: 32 })
            })
        )
    });

    const onSubmit = () => {
        handleSubmit(async (payload) => {
            const { data } = await axiosInstance.post("superadmin/login", payload);

            const superadminData = {
                user: {
                    ...data?.user,
                    role: SUPERADMIN_ROLE
                },
                token: data?.["token-superadmin"]
            };

            setItemToStore("token-superadmin", data?.["token-superadmin"]);
            setItemToStore("loginViaSuperadmin", true);
            handlePanelAbility({ userInfo: superadminData });
            handleUserData(superadminData);
            navigate(SuperAdminDefaultRoute, { replace: true });
        })();
    };

    const handleKeyPress = (e) => {
        if (e.key === "Enter") {
            e.preventDefault();
            onSubmit();
        }
    };

    return {
        onSubmit,
        errors,
        control,
        loading,
        handleKeyPress
    };
};

export default useSuperadminLogin;
